module.exports = __webpack_public_path__ + "img/plyr-muted.c1f140ca.svg";